let counter = 0;
let selector = "bcp-r4q-button-wrapper"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);

        const wishlist = document.querySelector('.product-form__wishlist');
        const quoteBtn = document.querySelector('bcp-r4q-button-wrapper');

        if (wishlist && quoteBtn) {
            quoteBtn.parentNode.insertBefore(wishlist, quoteBtn);
        }
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('product-info__price-current')) {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }